import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'Home', component: () => import('@/views/Home.vue'), meta: { navKey: 'nav.home' } },
  { path: '/products', name: 'Products', component: () => import('@/views/Products.vue'), meta: { navKey: 'nav.products' } },
  { path: '/products/:id', name: 'ProductDetail', component: () => import('@/views/ProductDetail.vue'), meta: { navKey: 'nav.products' } },
  { path: '/solutions', name: 'Solutions', component: () => import('@/views/Solutions.vue'), meta: { navKey: 'nav.solutions' } },
  { path: '/solutions/:id', name: 'SolutionDetail', component: () => import('@/views/SolutionDetail.vue'), meta: { navKey: 'nav.solutions' } },
  { path: '/cases', name: 'Cases', component: () => import('@/views/Cases.vue'), meta: { navKey: 'nav.cases' } },
  { path: '/cases/:id', name: 'CaseDetail', component: () => import('@/views/CaseDetail.vue'), meta: { navKey: 'nav.cases' } },
  { path: '/news', name: 'News', component: () => import('@/views/News.vue'), meta: { navKey: 'nav.news' } },
  { path: '/news/:id', name: 'ArticleDetail', component: () => import('@/views/ArticleDetail.vue'), meta: { navKey: 'nav.news' } },
  { path: '/about', name: 'About', component: () => import('@/views/About.vue'), meta: { navKey: 'nav.about' } },
  { path: '/contact', name: 'Contact', component: () => import('@/views/Contact.vue'), meta: { navKey: 'nav.contact' } },
  { path: '/downloads', name: 'Downloads', component: () => import('@/views/Downloads.vue'), meta: { navKey: 'nav.downloads' } },
  { path: '*', name: 'NotFound', component: () => import('@/views/NotFound.vue') }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() { return { x: 0, y: 0 } }
})

router.afterEach(() => {
  if (window.AOS) window.AOS.refresh()
})

export default router
